import { render, staticRenderFns } from "./AxPublishNotes.vue?vue&type=template&id=b4e45cb8&scoped=true&"
import script from "./AxPublishNotes.vue?vue&type=script&lang=ts&"
export * from "./AxPublishNotes.vue?vue&type=script&lang=ts&"
import style0 from "./AxPublishNotes.vue?vue&type=style&index=0&id=b4e45cb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e45cb8",
  null
  
)

export default component.exports